import {Directive, ElementRef, EventEmitter, Output} from '@angular/core';
import {NgModel} from '@angular/forms';

declare let google: any;

@Directive({
  selector: '[googleplace]',
  providers: [NgModel],
  host: {
    '(input)' : 'onInputChange()'
  }
})
export class GoogleplaceDirective  {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  modelValue: any;
  autocomplete: any;
  private readonly _el: HTMLElement;


  constructor(el: ElementRef, private readonly model: NgModel) {
    this._el = el.nativeElement;
    this.modelValue = this.model;
    const input = this._el;
    const options = {
        types: ['(cities)'],
        componentRestrictions: { 'country': ['ca'] }
    };
    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
        const place = this.autocomplete.getPlace();
        this.invokeEvent(place);
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  onInputChange() {
    const value = (<HTMLInputElement>this._el).value;
    const desired = value.replace(/[^a-zA-Z \-\']/gi, '');
    (<HTMLInputElement>this._el).value = desired;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/googleplace.directive.ts